// components/OrderForm.jsx
import React, { useState, useEffect } from 'react';
import API from '../api/MainApi.js';
import './OrderForm.css';

const OrderForm = ({ order, onSubmit, onClose }) => {
    const [products, setProducts] = useState([]);
    const [formData, setFormData] = useState({
        user: {
            fname: '',
            sname: '',
            tname: '',
            mobile: '',
            email: '',
            tg: '',
            vk: '',
            addres: ''
        },
        positions: [],
        totalPrice: 0,
        status: 'new',
        trackingNumber: ''
    });
    const [selectedProduct, setSelectedProduct] = useState('');
    const [selectedQuantity, setSelectedQuantity] = useState(1);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadProducts();
        if (order) {
            // Заполняем форму данными заказа
            setFormData({
                user: {
                    fname: order.user?.fname || '',
                    sname: order.user?.sname || '',
                    tname: order.user?.tname || '',
                    mobile: order.user?.mobile || '',
                    email: order.user?.email || '',
                    tg: order.user?.tg || '',
                    vk: order.user?.vk || '',
                    addres: order.user?.addres || ''
                },
                positions: order.positions?.map(p => ({
                    productId: p.productId?._id || p.productId,
                    quantity: p.quantity
                })) || [],
                totalPrice: order.totalPrice || 0,
                status: order.status || 'new',
                trackingNumber: order.trackingNumber || ''
            });
        }
    }, [order]);

    const loadProducts = async () => {
        try {
            const res = await API.getProducts();
            setProducts(res.data || []);
        } catch (error) {
            console.error('Error loading products:', error);
        }
    };

    const handleAddProduct = () => {
        if (!selectedProduct) {
            alert('Выберите товар');
            return;
        }
        const product = products.find(p => p._id === selectedProduct);
        if (!product) return;
        const existing = formData.positions.find(p => p.productId === selectedProduct);
        if (existing) {
            alert('Этот товар уже добавлен. Измените количество в списке.');
            return;
        }
        setFormData(prev => ({
            ...prev,
            positions: [...prev.positions, { productId: selectedProduct, quantity: selectedQuantity }]
        }));
        setSelectedProduct('');
        setSelectedQuantity(1);
    };

    const handleRemoveProduct = (index) => {
        const newPositions = [...formData.positions];
        newPositions.splice(index, 1);
        setFormData(prev => ({ ...prev, positions: newPositions }));
    };

    const handleQuantityChange = (index, newQuantity) => {
        const newPositions = [...formData.positions];
        newPositions[index].quantity = Math.max(1, parseInt(newQuantity) || 1);
        setFormData(prev => ({ ...prev, positions: newPositions }));
    };

    const calculateTotal = () => {
        let total = 0;
        for (const pos of formData.positions) {
            const product = products.find(p => p._id === pos.productId);
            if (product) total += product.price * pos.quantity;
        }
        return total;
    };

    const handleUserInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            user: { ...prev.user, [name]: value }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.positions.length === 0) {
            alert('Добавьте хотя бы один товар');
            return;
        }

        setLoading(true);

        const orderPayload = {
            user: formData.user,
            positions: formData.positions,
            totalPrice: formData.totalPrice || calculateTotal(),
            status: formData.status,
            trackingNumber: formData.trackingNumber
        };

        try {
            await onSubmit(orderPayload);
            onClose();
        } catch (error) {
            console.error('Error submitting order:', error);
            alert(error.response?.data?.message || 'Ошибка при сохранении заказа');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="order-form-modal">
            <div className="order-form-container">
                <div className="form-header">
                    <h3>{order ? 'Редактирование заказа' : 'Новый заказ'}</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-section">
                        <h4>Данные покупателя</h4>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Фамилия</label>
                                <input
                                    type="text"
                                    name="sname"
                                    value={formData.user.sname}
                                    onChange={handleUserInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Имя</label>
                                <input
                                    type="text"
                                    name="fname"
                                    value={formData.user.fname}
                                    onChange={handleUserInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Отчество</label>
                                <input
                                    type="text"
                                    name="tname"
                                    value={formData.user.tname}
                                    onChange={handleUserInputChange}
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Телефон</label>
                                <input
                                    type="tel"
                                    name="mobile"
                                    value={formData.user.mobile}
                                    onChange={handleUserInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.user.email}
                                    onChange={handleUserInputChange}
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Telegram</label>
                                <input
                                    type="text"
                                    name="tg"
                                    value={formData.user.tg}
                                    onChange={handleUserInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>VK</label>
                                <input
                                    type="text"
                                    name="vk"
                                    value={formData.user.vk}
                                    onChange={handleUserInputChange}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Адрес доставки</label>
                            <input
                                type="text"
                                name="addres"
                                value={formData.user.addres}
                                onChange={handleUserInputChange}
                            />
                        </div>
                    </div>

                    <div className="form-section">
                        <h4>Состав заказа</h4>
                        <div className="add-product-row">
                            <select
                                value={selectedProduct}
                                onChange={e => setSelectedProduct(e.target.value)}
                            >
                                <option value="">Выберите товар</option>
                                {products.map(product => (
                                    <option key={product._id} value={product._id}>
                                        {product.title} — {product.price} ₽
                                    </option>
                                ))}
                            </select>
                            <input
                                type="number"
                                min="1"
                                value={selectedQuantity}
                                onChange={e => setSelectedQuantity(parseInt(e.target.value) || 1)}
                            />
                            <button type="button" onClick={handleAddProduct}>Добавить</button>
                        </div>

                        {formData.positions.length > 0 && (
                            <div className="positions-list">
                                {formData.positions.map((pos, idx) => {
                                    const product = products.find(p => p._id === pos.productId);
                                    if (!product) return null;
                                    return (
                                        <div key={idx} className="position-item">
                                            <span>{product.title} — {product.price} ₽</span>
                                            <div className="position-controls">
                                                <input
                                                    type="number"
                                                    min="1"
                                                    value={pos.quantity}
                                                    onChange={e => handleQuantityChange(idx, e.target.value)}
                                                />
                                                <button type="button" onClick={() => handleRemoveProduct(idx)}>Удалить</button>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className="positions-total">
                                    Итого: {calculateTotal()} ₽
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="form-section">
                        <h4>Детали заказа</h4>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Сумма (можно переопределить)</label>
                                <input
                                    type="number"
                                    value={formData.totalPrice}
                                    onChange={e => setFormData(prev => ({ ...prev, totalPrice: parseFloat(e.target.value) || 0 }))}
                                />
                            </div>
                            <div className="form-group">
                                <label>Статус</label>
                                <select
                                    value={formData.status}
                                    onChange={e => setFormData(prev => ({ ...prev, status: e.target.value }))}
                                >
                                    <option value="new">Новый</option>
                                    <option value="accepted">Принят</option>
                                    <option value="shipped">Отправлен</option>
                                    <option value="completed">Завершён</option>
                                    <option value="cancelled">Отменён</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Номер отслеживания (трек-номер)</label>
                            <input
                                type="text"
                                value={formData.trackingNumber}
                                onChange={e => setFormData(prev => ({ ...prev, trackingNumber: e.target.value }))}
                                placeholder="Введите трек-номер, если есть"
                            />
                        </div>
                    </div>

                    <div className="form-actions">
                        <button type="button" onClick={onClose}>Отмена</button>
                        <button type="submit" disabled={loading}>
                            {loading ? 'Сохранение...' : (order ? 'Сохранить' : 'Создать заказ')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default OrderForm;